import AppsView from '@/views/AppsView.vue'
import HomeView from '@/views/HomeView.vue'
import { createRouter, createWebHistory } from 'vue-router'
import { requireCatalogAccess } from './middleware/requireCatalogAccess'
import { requireBenderAccess } from './middleware/requireBenderAccess'
import { handleRouterError } from './middleware/handleRouterError'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
      meta: {
        menuName: 'Home',
        menuIcon: 'mdi-home',
      },
    },
    {
      path: '/apps',
      name: 'apps',
      component: AppsView,
      meta: {
        menuName: 'Apps',
        menuIcon: 'mdi-apps',
        permission: 'my',
      },
    },
    {
      path: '/:pathMatch(.*)*',
      name: '404',
      component: () => import('../views/404View.vue'),
      meta: {
        login: 'optional',
      },
    },
    {
      path: '/assets/:id',
      name: 'assets',
      component: () => import('../views/AssetsView.vue'),
      meta: {
        login: 'optional',
        permission: 'implanter',
      },
    },
    {
      path: '/users',
      name: 'users',
      meta: {
        menuName: 'Users',
        menuIcon: 'mdi-account-circle',
        permission: 'read:users',
      },
      children: [
        {
          path: '',
          component: () => import('../views/users/UsersView.vue'),
          children: [
            {
              path: '',
              component: () => import('../components/UsersTable.vue'),
            },
            {
              path: 'invitations',
              component: () => import('../components/InvitationsTable.vue'),
            },
          ],
        },
        {
          path: ':id',
          component: () => import('../views/users/UserCardView.vue'),
        },
      ],
    },
    {
      path: '/account',
      name: 'account',
      component: () => import('../views/AccountView.vue'),
    },
    {
      path: '/onBoarding',
      name: 'onBoarding',
      meta: {
        menuName: 'OnBoarding',
        menuIcon: 'mdi-account-plus',
        permission: 'my',
      },
      component: () => import('../views/OnBoardingView.vue'),
    },
    {
      path: '/admin',
      name: 'admin',
      meta: {
        menuName: 'Admin',
        menuIcon: 'mdi-shield-account',
        header: 'Admin',
        permission: 'read:organizations', // TODO Phase 0: confirm a perm held by both tiers
      },
      children: [
        {
          path: '',
          component: () => import('../views/admin/AdminView.vue'),
          children: [
            {
              path: '',
              component: () => import('../components/admin/OrganizationsTable.vue'),
            },
            {
              path: 'users',
              component: () => import('../components/admin/AdminUsersTable.vue'),
            },
            {
              path: 'feature-flags',
              component: () => import('../components/admin/AdminFeatureFlagsTable.vue'),
            },
            {
              path: 'customer-access',
              component: () => import('../components/admin/AdminCustomerAccessTable.vue'),
            },
            {
              path: 'metrics',
              component: () => import('../components/admin/AdminCatalogMetricsTable.vue'),
              beforeEnter: requireCatalogAccess,
            },
            {
              path: 'layers',
              component: () => import('../components/admin/AdminCatalogLayersTable.vue'),
              beforeEnter: requireCatalogAccess,
            },
            {
              path: 'audit-log',
              component: () => import('../components/admin/AdminAuditLogTable.vue'),
              beforeEnter: requireBenderAccess,
            },
          ],
        },
        {
          path: 'organizations/:id',
          component: () => import('../views/admin/OrganizationCardView.vue'),
        },
      ],
    },
    {
      path: '/settings',
      name: 'settings',
      meta: {
        menuName: 'Settings',
        menuIcon: 'mdi-cog',
        permission: 'read:settings',
      },
      children: [
        {
          path: '',
          component: () => import('../views/settings/SettingsView.vue'),
          children: [
            {
              path: '',
              component: () => import('../views/settings/index/SettingsSsoView.vue'),
            },
            {
              path: 'sso',
              component: () => import('../views/settings/index/SettingsSsoView.vue'),
            },
          ],
        },
      ],
    },
  ],
})

router.onError(handleRouterError)

export default router
